import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { AssetList } from '@features/assets/components/asset-list/asset-list';
import { IAssetListItem } from '@features/assets/components/asset-card/asset-list-item.types';

/** "Program kanala" tab — the channel's programme, current event highlighted + scrolled into view. */
@Component({
    selector: 'details-live',
    standalone: true,
    imports: [AssetList],
    template: `
        <asset-list [items]="items()" size="small" [showTime]="true" [skeletonOnScroll]="true"
            [selectedId]="selectedId()" (itemClick)="openItem.emit($event)" />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailsLive {
    readonly items = input.required<readonly IAssetListItem[]>();
    readonly selectedId = input<string | null>(null);

    readonly openItem = output<IAssetListItem>();
}
